var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s3m-list_field"},[_c('div',[_c('ul',{staticClass:"form-control"},_vm._l((_vm.list),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }